import { ASSIGNED_NODE_TAG } from '@fullstory/shared/node_decoder';
import { DirtyBit } from './dirtybits';
import type { FsDocument } from './fsdocument';
import { FsNode } from './fsnode';

export class FsSlotElement extends FsNode {
  constructor(ownerDoc: FsDocument, fsid?: number) {
    super(ownerDoc, 'slot', '', fsid);
  }

  private _assignedNode: FsNode | undefined = undefined;
  insert(child: FsNode, realBefore: FsNode | null): void {
    if (child.tag === ASSIGNED_NODE_TAG) {
      this._setAssigned(child);
    }
    super.insert(child, realBefore);
  }

  removeChild(child: FsNode): void {
    if (child.tag === ASSIGNED_NODE_TAG) {
      this._setAssigned(undefined);
    }
    super.removeChild(child);
  }

  private _setAssigned(node: FsNode | undefined) {
    if (this._assignedNode === node) {
      return;
    } else if (this._assignedNode) {
      console.warn(
        'detected more than one assigned nodes pseudo node; this likely indicates a bug',
      );
    }

    this._assignedNode = node;
    this.setDirtyBit(DirtyBit.ChildList);
  }

  /**
   * When this slot has no assigned nodes (absent of a ASSIGNED_NODE_TAG child), render direct children
   * otherwise, render assigned children only
   */
  protected renderChild(child: FsNode) {
    // returns true iff:
    // 1. super says we should render this child, and
    // 2. if we have an assigned node; only render the assigned node
    //      otherwise, render all non assigned nodes
    return super.renderChild(child) && !!this._assignedNode === (child.tag === ASSIGNED_NODE_TAG);
  }

  setDirtyBit(bit: DirtyBit) {
    if (this._assignedNode && bit === DirtyBit.ChildList) {
      // since assigned nodes flush to the same dom, if our child list changes, we also need to reflush it
      this._assignedNode.setDirtyBit(DirtyBit.ChildList);
    }

    super.setDirtyBit(bit);
  }
}
